const avgProp = (touches, prop) =>
	Array.prototype.reduce.call(touches, (acc, touch) => acc + touch[prop], 0) /
	touches.length;
export const center = touches =>
	["clientX", "clientY"].map(prop => avgProp(touches, prop));
export const distance = (a, b) =>
	Math.sqrt(
		Math.pow(a.clientX - b.clientX, 2) + Math.pow(a.clientY - b.clientY, 2),
	);
